import { render } from "./BoardView.vue?vue&type=template&id=1239f399"
import script from "./BoardView.vue?vue&type=script&lang=js"
export * from "./BoardView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__